/** Coordinates the shared header field without replacing either search engine. */
(() => {
  if (window.BpHeaderSearch) return;
  const formSelector = '[data-bp-header-search]';
  let openingNative = false;
  let previousProvider;

  function syncProvider() {
    const state = window.BpSearchPolicy?.update() || { provider: 'shopify', reason: 'unavailable' };
    if (state.provider === 'shopify' && previousProvider === 'rapid') {
      document.querySelector('.rps_search_overlay_close')?.click();
    }
    if (state.provider === 'shopify') {
      document.querySelectorAll('style[id^="rps-theme-section-style-"]').forEach(style => { style.media = 'not all'; });
    }
    document.querySelectorAll(`${formSelector} input[name="q"]`).forEach(input => {
      // Missing app settings may arrive later. Keep that input discoverable.
      input.classList.toggle('rps_ignore_search_input', state.provider === 'shopify' && state.reason !== 'unavailable');
    });
    previousProvider = state.provider;
    return state;
  }

  async function openNative(query = '') {
    const drawer = document.getElementById('search-drawer');
    if (!drawer || typeof drawer.show !== 'function' || openingNative) return false;
    openingNative = true;
    try {
      const input = drawer.querySelector('input[name="q"]');
      if (!input) return false;
      input.value = query;
      await drawer.show();
      input.focus({ preventScroll: true });
      input.dispatchEvent(new Event('input', { bubbles: true }));
      return true;
    } finally {
      openingNative = false;
    }
  }

  function onHeaderEvent(event) {
    if (!(event.target instanceof Element)) return;
    const trigger = event.target.closest('[data-bp-search-trigger]');
    const form = event.target.closest(formSelector);
    if (!form && !trigger) return;
    const state = syncProvider();

    if (trigger && event.type === 'click') {
      if (state.provider === 'rapid' && document.querySelector('.rps_search_overlay_input')) {
        event.preventDefault();
        event.stopImmediatePropagation();
        window.dispatchEvent(new CustomEvent('rapidsearchshowfullpageoverlay'));
      } else if (typeof document.getElementById('search-drawer')?.show === 'function') {
        event.preventDefault();
        event.stopImmediatePropagation();
        void openNative();
      }
      return;
    }

    if (!form || state.provider !== 'shopify') return;
    // Block only the header field's app handlers. The browser's normal GET
    // submission still works, including if the native drawer is unavailable.
    event.stopImmediatePropagation();
    if ((event.type === 'focusin' || event.type === 'click') && event.target.matches('input[name="q"]')) {
      void openNative(event.target.value);
    }
  }

  window.BpHeaderSearch = { syncProvider };
  ['click', 'focusin', 'input', 'keydown', 'keyup', 'submit'].forEach(type => {
    window.addEventListener(type, onHeaderEvent, true);
  });
  window.addEventListener('pageshow', syncProvider);
  document.addEventListener('shopify:section:load', syncProvider);
  window.addEventListener('rps-instantsearch-rendered', syncProvider);
  syncProvider();
})();
